import { render, staticRenderFns } from "./emoji-grid.vue?vue&type=template&id=7b74f293&scoped=true&"
import script from "./emoji-grid.vue?vue&type=script&lang=js&"
export * from "./emoji-grid.vue?vue&type=script&lang=js&"
import style0 from "./emoji-grid.vue?vue&type=style&index=0&id=7b74f293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74f293",
  null
  
)

export default component.exports